import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import { useAppSelector } from '../../modules/hooks';
import { selectIsWatchtimeFetched } from '../../modules/fetching';
import { isNewlyReleased } from '../../shared/helpers/assetHelpers';
import { unleash } from '../../services/unleash';

import { useServerTime } from './useServerTime';
import { useAssetWatchtimeData } from './useAssetWatchtimeData';

export const useAssetRelease = (asset?: SvpAssetAdditional) => {
  const { serverTime } = useServerTime();
  const { watchtime } = useAssetWatchtimeData(asset?.id, asset?.provider);
  const isWatchtimeFetched = useAppSelector((state) =>
    asset ? selectIsWatchtimeFetched(state, asset.id, asset.provider) : false
  );

  let isNew = Boolean(asset && isNewlyReleased(asset, serverTime));

  return {
    isNewlyReleased: unleash.isEnabled('watchtime')
      ? isNew && isWatchtimeFetched && !watchtime?.time
      : isNew,
  };
};
